import { useState } from 'react'

import { env } from 'src/config/env'
import { Headset } from 'src/shared/components/icons/headset'
import useBreakpoint from 'src/shared/hooks/use-breakpoint'
import { useWindowSize } from 'src/shared/hooks/use-window-size'
import { cn } from 'src/shared/utils/cn'

import { SupportDialogControlled } from '../../support/components/support-dialog'

// import EnterpriseAuthSideContent from './side-content'

interface AuthSideContentContainerProps {
  children: React.ReactNode
}

function AuthSideContentContainer({ children }: AuthSideContentContainerProps) {
  const { isMobile } = useBreakpoint()

  return (
    <div
      className={cn(
        'relative flex flex-1 flex-col overflow-hidden rounded-[40px] bg-white',
        isMobile && 'w-full border border-border shadow-[0_2px_20px_0_rgba(27,48,41,0.05)]',
      )}
    >
      {children}
      {/* {variant === 'default' && <SideContent />}
      {variant === 'consumer' && <ConsumerSideContent />} */}
    </div>
  )
}

interface AuthLayoutBaseProps {
  children: React.ReactNode
  sideContent?: React.ReactNode
  linksVariant?: 'help' | 'help-and-privacy'
}

export default function AuthLayoutBase({ children, sideContent, linksVariant = 'help' }: AuthLayoutBaseProps) {
  const { isMobile } = useBreakpoint()
  const { width } = useWindowSize()
  const [supportDialogOpen, setSupportDialogOpen] = useState(false)

  const handleHelpClick = () => {
    setSupportDialogOpen(true)
  }

  const handlePrivacyPolicyClick = () => {
    window.open(env.LINK_TO_PRIVACY_POLICY, '_blank')
  }

  if (isMobile) {
    // Mobile version
    return <div className="flex min-h-screen w-full bg-white px-[25px]">{children}</div>
  }

  return (
    // Desktop version
    <div className="relative flex min-h-screen w-full items-center justify-center bg-accent px-[25px] xs:px-8 xs:py-16">
      <div
        className={cn(
          'mx-auto flex min-h-[750px] w-full max-w-[1330px] flex-row gap-[30px]',
          width < 1000 && 'mt-2 min-h-[1500px] flex-col',
          width < 1000 && linksVariant === 'help-and-privacy' && 'mb-5 mt-0',
        )}
      >
        {children}
        <AuthSideContentContainer>{sideContent}</AuthSideContentContainer>
      </div>

      {/* Needs help link */}
      {linksVariant === 'help' && (
        <div className="absolute right-[35px] top-[28px] flex flex-row items-center text-[14px] text-muted">
          <Headset size={20} className="mr-2 text-primary" />
          {'Need help?'}
          <div className="cursor-pointer" onClick={handleHelpClick}>
            <p className="ml-1 text-primary underline">{'Click here'}</p>
          </div>
        </div>
      )}

      {/* Needs help and privacy links */}
      {linksVariant === 'help-and-privacy' && (
        <div className="absolute inset-x-0 bottom-0 flex flex-row items-center justify-end gap-10 px-[43px] py-[34px] text-[13px] text-muted">
          <div className="cursor-pointer" onClick={handleHelpClick}>
            <p>{'Need help'}</p>
          </div>
          <div className="cursor-pointer" onClick={handlePrivacyPolicyClick}>
            <p>{'Privacy policy'}</p>
          </div>
        </div>
      )}

      {/* Support dialog */}
      <SupportDialogControlled open={supportDialogOpen} setOpen={setSupportDialogOpen} />
    </div>
  )
}
